import Vue from "vue";
import Router from "vue-router";
import Home from "../views/Home.vue";
Vue.use(Router);
var frontRoutes = [{
  path: "/index",
  name: "Index",
  component: function component() {
    return import(
    /* webpackChunkName: "index" */
    "../views/Index.vue");
  }
}, {
  path: "/index/rec-teacher",
  name: "IndexRecommendTeacher",
  component: function component() {
    return import(
    /* webpackChunkName: "common" */
    "../views/ShowTeachers.vue");
  }
}, {
  path: "/searchResult",
  name: "SearchResult",
  component: function component() {
    return import(
    /* webpackChunkName: "index" */
    "../views/SearchResult.vue");
  }
}, {
  path: "/about",
  name: "About",
  component: function component() {
    return import(
    /* webpackChunkName: "common" */
    "../views/About.vue");
  }
}, {
  path: "/show-teachers",
  name: "ShowTeachers",
  component: function component() {
    return import(
    /* webpackChunkName: "common" */
    "../views/ShowTeachers.vue");
  }
}, {
  path: "/show-teachers/showTeachersDetaial/:id",
  name: "ShowTeachersDetaial",
  component: function component() {
    return import(
    /* webpackChunkName: "common" */
    "../views/oto/OtoTeacherShow.vue");
  }
}, {
  path: "/show-teachers/adminIndex",
  name: "TeacherAdminIndex",
  component: function component() {
    return import("../views/TeacherAdminIndex.vue");
  }
}, {
  path: "/inviteTeacher",
  name: "ShowAppointmentTeachers",
  component: function component() {
    return import(
    /* webpackChunkName: "common" */
    "../views/ShowAppointmentTeachers.vue");
  }
}, // {
//   path: "/vip",
//   name: "MemberVip",
//   component: () =>
//     import(
//       /* webpackChunkName: "member" */
//       "../views/member/MemberVip.vue"
//     ),
// },
{
  path: "/contact",
  name: "ContactUs",
  component: function component() {
    return import(
    /* webpackChunkName: "common" */
    "../views/ContactUs.vue");
  }
}, {
  path: "/help",
  name: "HelpCenter",
  component: function component() {
    return import(
    /* webpackChunkName: "common" */
    "../views/HelpCenter.vue");
  }
}, {
  path: "/integral/goods/:id",
  name: "IntegralGoodsDetail",
  component: function component() {
    return import(
    /* webpackChunkName: "integral" */
    "../views/integral/IntegralGoodsDetail.vue");
  }
}];
var memberRoutes = [{
  path: "/member/address",
  name: "MemberAddress",
  component: function component() {
    return import(
    /* webpackChunkName: "member" */
    "../views/member/MemberAddress.vue");
  },
  meta: {
    requireAuth: true,
    title: "收货地址",
    root: true
  }
}, {
  path: "/member/profile",
  name: "MemberProfile",
  component: function component() {
    return import(
    /* webpackChunkName: "member" */
    "../views/member/MemberProfile.vue");
  },
  meta: {
    requireAuth: true,
    title: "个人设置",
    root: true
  }
}, {
  path: "/member/wealth",
  name: "MemberWealth",
  component: function component() {
    return import(
    /* webpackChunkName: "member" */
    "../views/member/MemberWealth.vue");
  },
  meta: {
    requireAuth: true,
    title: "我的财富",
    root: true
  }
}, {
  path: "/member/myConsultation",
  name: "MemberMyConsultation",
  component: function component() {
    return import(
    /* webpackChunkName: "member" */
    "../views/member/MemberMyConsultation.vue");
  },
  meta: {
    requireAuth: true,
    title: "我的咨询",
    root: true
  }
}, {
  path: "/member/message",
  name: "MemberMessage",
  component: function component() {
    return import(
    /* webpackChunkName: "member" */
    "../views/member/MemberMessage.vue");
  },
  meta: {
    requireAuth: true,
    title: "消息中心",
    root: true
  }
}, {
  path: "/member/integral",
  name: "MemberIntegral",
  component: function component() {
    return import(
    /* webpackChunkName: "member" */
    "../views/member/integral/MemberIntegral.vue");
  },
  meta: {
    requireAuth: true,
    title: "我的积分",
    root: true
  }
}, {
  path: "/member/clockin",
  name: "MemberClockin",
  component: function component() {
    return import(
    /* webpackChunkName: "member" */
    "../views/member/MemberClockin.vue");
  },
  meta: {
    requireAuth: true,
    title: "我的打卡",
    root: true
  }
}, {
  path: "/member/cert",
  name: "MemberCert",
  component: function component() {
    return import(
    /* webpackChunkName: "member" */
    "../views/member/MemberCert.vue");
  },
  meta: {
    requireAuth: true,
    title: "我的证书",
    root: true
  }
}, {
  path: "/member/ebook",
  name: "MemberEbooks",
  component: function component() {
    return import(
    /* webpackChunkName: "member" */
    "../views/member/MemberEbooks.vue");
  },
  meta: {
    requireAuth: true,
    title: "我的电子书",
    root: true
  }
}];

(function () {
  var files = require.context(".", false, /.js$/);

  var keys = files.keys();
  keys.forEach(function (key) {
    if (key.indexOf("index.js") > 0) {
      return;
    }

    var router = files(key).default;

    if (router.frontRoutes) {
      frontRoutes = frontRoutes.concat(router.frontRoutes);
    }

    if (router.memberRoutes) {
      memberRoutes = memberRoutes.concat(router.memberRoutes);
    }
  });
})();

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [{
    path: "/ebooks/reader/:id",
    name: "EbooksReader",
    component: function component() {
      return import(
      /* webpackChunkName: "book" */
      "../views/ebooks/EbooksReader.vue");
    }
  }, {
    path: "/",
    name: "Home",
    redirect: "/index",
    component: Home,
    children: frontRoutes
  }, {
    path: "/member",
    name: "Member",
    component: function component() {
      return import(
      /* webpackChunkName: "member" */
      "../views/member/Member.vue");
    },
    meta: {
      requireAuth: true
    },
    children: memberRoutes
  }, {
    path: "/download",
    name: "Download",
    component: function component() {
      return import(
      /* webpackChunkName: "download" */
      "../views/Download.vue");
    }
  }, {
    path: "/download-client",
    name: "DownloadClient",
    component: function component() {
      return import(
      /* webpackChunkName: "download-client" */
      "@/components/DownloadClient");
    },
    meta: {
      title: "直播客户端"
    }
  }, {
    path: "/video",
    name: "Video",
    component: function component() {
      return import(
      /* webpackChunkName: "course" */
      "../views/course/Video.vue");
    }
  }, {
    path: "/login",
    name: "Login",
    component: function component() {
      return import(
      /* webpackChunkName: "login" */
      "../views/Login.vue");
    }
  }, {
    path: "/contract",
    name: "Contract",
    component: function component() {
      return import(
      /* webpackChunkName: "login" */
      "../views/Contract.vue");
    }
  }, {
    path: "/live",
    name: "Live",
    component: function component() {
      return import(
      /* webpackChunkName: "live" */
      "../views/Live.vue");
    }
  }, {
    path: "/regist-information",
    name: "RegistInformation",
    component: function component() {
      return import(
      /* webpackChunkName: "regist-information" */
      "../views/RegistInformation.vue");
    }
  }, {
    path: "/custom/:id",
    name: "CustomPage",
    component: function component() {
      return import(
      /* webpackChunkName: "custom-page" */
      "../views/CustomPage.vue");
    }
  }]
});